import { SelectedDocumentRow } from "../../OrganizationDocumentsActions/OrganizationDocumentsActions"

export default function inSubmittedDocumentState(selection: SelectedDocumentRow[]): boolean {
    return selection.every(row => row?.documentState?.code === "SUBMITTED")
}
